import React, { useRef, useState, useEffect } from 'react';

import './styles.css';

import Popup from '../../Popup';
import urlToFile from './../../../functions/urlToFile';
import Webcam from 'react-webcam';
import { FaCamera } from 'react-icons/fa';

function PopupNewPhoto(props) {
    const webcamRef = useRef(null);
    const [actualImage, setActualImage] = useState('');

    const onCapture = () => {
        const imageSrc = webcamRef.current.getScreenshot();
        setActualImage(imageSrc);
    }

    const onConfirm = () => {
        props.setPhoto(urlToFile(actualImage, "foto.png"));
        props.setVisibility(false);
    }

    const onReset = () => {
        setActualImage(null);
    }

    useEffect(() => {
        if (props.visibility === false)
            setActualImage(null);
    }, [props.visibility]);

    return (
        <Popup
            visibility={props.visibility}
            setVisibility={props.setVisibility}
            tittle="Nova Foto"
            icon={<FaCamera />}
        >
            <div>
                {props.visibility ?
                    (actualImage === null ?
                        <Webcam
                            ref={webcamRef}
                            screenshotFormat='image/png'
                            width={'100%'}
                        />
                        :
                        <img src={actualImage} alt="Foto tirada da webcam"/>
                    )
                    : null
                }
            </div>
            <div className="popup-new-photo-buttons">
                {actualImage === null ?
                    <button type="button" className="new-photo-button-take" onClick={onCapture}>Tirar Foto</button>
                    :
                    <>
                        <button type="button" className="new-photo-button-again light-blue" onClick={onReset}>Tentar novamente</button>
                        <button type="button" className="new-photo-button-confirm" onClick={onConfirm}>Confirmar</button>
                    </>
                }
            </div>
        </Popup>
    )
}

export default PopupNewPhoto;